<template>
  <a-card :bordered="true" title="完成养护情况">
    <a-form :form="form">
      <a-form-item label="id" v-show="false">
        <a-input :disabled="showable" v-decorator="['id']" />
      </a-form-item>
      <table class="ant-table table ant-table-bordered">
        <thead class="ant-table-thead ant-table-bordered">
          <tr>
            <th width="100px">工作内容</th>
            <th width="100px">使用数量</th>
            <th width="100px">作业面积</th>
            <th width="100px">备注</th>
          </tr>
        </thead>
        <tbody class="ant-table-tbody ant-table-bordered">
          <tr>
            <td>
              <a-form-item>
                <a-select
                  style="width: 70%"
                  showSearch
                  :disabled="showable"
                  placeholder="浇水"
                  v-decorator="['wateringTypeId', {rules: [{required: false, message: '请选择浇水类型'}]}]"
                  :options="dropDownWateringList"
                  optionFilterProp="children"
                />
              </a-form-item>
            </td>
            <td>
              <a-form-item>
                <a-input-number
                  :precision="0.1"
                  :min="0"
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['wateringNumber']"
                />
              </a-form-item>
            </td>
            <td>
              <a-form-item>
                <a-input-number
                  :precision="0.1"
                  :min="0"
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['wateringArea']"
                />
              </a-form-item>
            </td>
            <td>
              <a-form-item>
                <a-input
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['wateringRemark']"
                />
              </a-form-item>
            </td>
          </tr>
          <tr>
            <td>打药</td>
            <td>
              <a-form-item>
                <a-input-number
                  :precision="0.1"
                  :min="0"
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['medicineNumber']"
                />
              </a-form-item>
            </td>
            <td>
              <a-form-item>
                <a-input-number
                  :precision="0.1"
                  :min="0"
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['medicineArea']"
                />
              </a-form-item>
            </td>
            <td>
              <a-form-item>
                <a-input
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['medicineRemark']"
                />
              </a-form-item>
            </td>
          </tr>
          <tr>
            <td>施肥</td>
            <td>
              <a-form-item>
                <a-input-number
                  :precision="0.1"
                  :min="0"
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['fertilizerNumber']"
                />
              </a-form-item>
            </td>
            <td>
              <a-form-item>
                <a-input-number
                  :precision="0.1"
                  :min="0"
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['fertilizerArea']"
                />
              </a-form-item>
            </td>
            <td>
              <a-form-item>
                <a-input
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['fertilizerRemark']"
                />
              </a-form-item>
            </td>
          </tr>
          <tr>
            <td>
              <a-form-item>
                <a-select
                  style="width: 70%"
                  showSearch
                  :disabled="showable"
                  placeholder="修剪"
                  v-decorator="['trimTypeId', {rules: [{required: false, message: '请选择修剪类型'}]}]"
                  :options="dropDownPruneList"
                  optionFilterProp="children"
                />
              </a-form-item>
            </td>
            <td>--</td>
            <td>
              <a-form-item>
                <a-input-number
                  :precision="0.1"
                  :min="0"
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['trimArea']"
                />
              </a-form-item>
            </td>
            <td>
              <a-form-item>
                <a-input
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['trimRemark']"
                />
              </a-form-item>
            </td>
          </tr>
          <tr>
            <td>拔草</td>
            <td>--</td>
            <td>
              <a-form-item>
                <a-input-number
                  :precision="0.1"
                  :min="0"
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['weedArea']"
                />
              </a-form-item>
            </td>
            <td>
              <a-form-item>
                <a-input
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['weedRemark']"
                />
              </a-form-item>
            </td>
          </tr>
          <tr>
            <td>其他</td>
            <td>
              <a-form-item>
                <a-input-number
                  :precision="0.1"
                  :min="0"
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['otherNumber']"
                />
              </a-form-item>
            </td>
            <td>
              <a-form-item>
                <a-input-number
                  :precision="0.1"
                  :min="0"
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['otherArea']"
                />
              </a-form-item>
            </td>
            <td>
              <a-form-item>
                <a-input
                  :disabled="showable"
                  style="width: 60%"
                  v-decorator="['otherRemark']"
                />
              </a-form-item>
            </td>
          </tr>
        </tbody>
      </table>
    </a-form>
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import AFormItem from 'ant-design-vue/es/form/FormItem'
export default {
  name: 'DailyCuringResult',
  components: { AFormItem },
  props: {
    dropDownWateringList: {
      type: Array,
      default: () => []
    },
    dropDownPruneList: {
      type: Array,
      default: () => []
    },
    dailyCuringResultSource: {
      type: Object,
      default: () => {}
    },
    childType: {
      type: String,
      default: 'add'
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      waterSwitch: false,
      medicineSwitch: false,
      fertilizerSwitch: false,
      trimSwitch: false,
      weedSwitch: false,
      otherSwitch: false,
      showable: false
    }
  },
  watch: {
    dailyCuringResultSource: function (newVal, oldVal) {
      this.dailyCuringResultSource = newVal
      const { form: { setFieldsValue, resetFields } } = this
      const pickFiled = ['id', 'wateringTypeId', 'wateringNumber', 'wateringArea', 'wateringRemark',
        'medicineNumber', 'medicineArea', 'medicineRemark', 'fertilizerNumber',
        'fertilizerArea', 'fertilizerRemark', 'trimTypeId', 'trimArea', 'trimRemark',
        'weedArea', 'weedRemark', 'otherNumber', 'otherArea', 'otherRemark']
      this.$nextTick(() => {
        setFieldsValue(pick(this.dailyCuringResultSource, pickFiled))
      })
      if (JSON.stringify(newVal) === '{}') {
        resetFields()
      }
    },
    childType (val) {
      this.childType = val
    }
  },
  mounted () {
    if (this.childType === 'show') {
      this.showable = true
    }
  }
}
</script>

<style scoped>
  .ant-form-item{
    margin-bottom: 0px !important;
  }
</style>
